var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","color":_vm.isMobile() ? 'white' : 'primary',"to":{ name: 'notificacoes' }}},[_c('v-icon',{attrs:{"size":_vm.isMobile() ? 25 : 33}},[_vm._v("mdi-bell-outline")]),(_vm.getQtdMsgNaoVisualizadas() > 0)?_c('span',{staticClass:"badge text-center"},[_vm._v(_vm._s(_vm.getQtdMsgNaoVisualizadas()))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }